import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  Typography,
  Divider,
  IconButton,
  Box,
  Snackbar,
  Alert,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { IRoleListDTO } from "../../interfaces/UserManagement";
import { activateDeactivateRole } from "../../services/UserManagement";

interface RoleConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  role: IRoleListDTO | null;
}

const RoleConfirmDialog = ({ open, onClose, onSave, role }: RoleConfirmDialogProps) => {
  const [msg, setMsg] = useState("");
  const [openError, setOpenError] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const action = role?.status === "Active" ? "Inactivate" : "Activate";

  const handleConfirm = async () => {
    if (!role?.roleId) return;
    setLoading(true);
    try {
      const res = await activateDeactivateRole(role.roleId);
      if (res && res.status === "success") {
        setOpenSuccess(true);
        setMsg("Successfully changed the Status");
        onSave();
        onClose();
      } else {
        setOpenError(true);
        setMsg("Failed to update status.");
      }
    } catch {
      setOpenError(true);
      setMsg("Unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };

  const handleSnackbarClose = () => {
    setOpenError(false);
    setOpenSuccess(false);
    setMsg("");
  };

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: "16px", border: "2px solid #D6E5FF", boxShadow: "20px 20px 20px 0 rgba(0, 0, 0, 0.08)" } }} slotProps={{ backdrop: { sx: { backdropFilter: "blur(4px)" } } }}>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", pb: 1, pr: 6 }}>
          <Box>
            <Typography sx={{ fontSize: "20px", fontWeight: 700, color: "text.primary" }}>Are you sure want to {action} the Role ?</Typography>
            <Typography sx={{ fontSize: "16px", fontWeight: 400, color: "#757A89", mt: 0.5 }}>
              {action === "Activate"
                ? "The Role will be Activated & All users in That Role regain there Access, you can Inactivate it later."
                : "The Role will be Inactive & All users in That Role loss there Access, you can Activate it later."}
            </Typography>
          </Box>
          <IconButton onClick={onClose} size="small" sx={{ position: "absolute", right: 16, top: 16 }}><CloseIcon /></IconButton>
        </DialogTitle>
        <Divider />
        <DialogActions sx={{ p: 2, justifyContent: "space-between" }}>
          <Button onClick={onClose} variant="outlined" sx={{ borderRadius: "28px", border: "1px solid #FE0909", bgcolor: "#FFF", color: "#FE0909", padding: "8px 16px", textTransform: "none", minWidth: "120px", "&:hover": { border: "1px solid #FE0909", bgcolor: "#FFF" } }}>No</Button>
          <Button onClick={handleConfirm} disabled={loading} variant="contained" sx={{ borderRadius: "28px", border: "1px solid #005EFF", bgcolor: "#005EFF", color: "#fff", padding: "8px 16px", textTransform: "none", minWidth: "120px", "&:hover": { bgcolor: "#005EFF" } }}>{loading ? <CircularProgress size={22} sx={{ color: "#fff" }} /> : "Yes"}</Button>
        </DialogActions>
      </Dialog>

      <Snackbar anchorOrigin={{ vertical: "top", horizontal: "right" }} open={openError} autoHideDuration={5000} onClose={handleSnackbarClose}>
        <Alert severity="error" variant="filled" sx={{ width: "100%" }}>{msg}</Alert>
      </Snackbar>
      <Snackbar anchorOrigin={{ vertical: "top", horizontal: "right" }} open={openSuccess} autoHideDuration={5000} onClose={handleSnackbarClose}>
        <Alert severity="success" variant="filled" sx={{ width: "100%" }}>{msg}</Alert>
      </Snackbar>
    </>
  );
};
export default RoleConfirmDialog;
